// extracted by mini-css-extract-plugin
module.exports = {"unread":"mailbox_unread__2xroK","date":"mailbox_date__1AGhm","noWrap":"mailbox_noWrap__1Xb8w","noChats":"mailbox_noChats__Yhcek"};